<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create Letterbook</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-model="entity.date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Body *</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">Pdf</label>
                      <div class="col-md-10">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzonePdf"
                          class="dropzone-noprogress"
                          :options="dropzoneOptions"
                          @vdropzone-removed-file="pdfChanged"
                          @vdropzone-file-added="pdfChanged"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">Pdf transcription</label>
                      <div class="col-md-10">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzonePdfText"
                          class="dropzone-noprogress"
                          :options="dropzoneOptions"
                          @vdropzone-removed-file="pdfTextChanged"
                          @vdropzone-file-added="pdfTextChanged"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">{{ item }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featuredBody" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        @changeRefs="$_changeRefs"
      />

      <terms
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Letterbook has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import Referencer from '@/global/components/Referencer';
import Datepicker from '@/global/components/Datepicker';
import Terms from '@/global/components/TermsEditor';
import config from '../../../config';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

// TODO: остановился здесь. Переделать компонент, чтобы тот мог загружать много файлов за раз.

export default {
  name: 'LetterbookNew',

  components: {
    dropzone: Dropzone,
    referencer: Referencer,
    datepicker: Datepicker,
    terms: Terms,
  },

  mixins: [CreatePageMixin],

  data() {
    return {
      entity: {
        title: null,
        body: null,
        summary: null,
        date: null,
        pdf: null,
        pdf_text: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: '',
      },
      dropzoneOptions: {
        url: '/', // There are no link because we dont need to upload files immediately
        maxFiles: 1,
        maxFilesize: 100,
        addRemoveLinks: true,
        acceptedFiles: 'application/pdf',
        autoProcessQueue: false,
        accept() {
        },
      },
    };
  },

  methods: {
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias, type: 'path' },
        { name: 'Body', value: this.entity.body, type: 'required' },
      ]);
    },
    pdfChanged() {
      [this.entity.pdf] = this.$refs.dropzonePdf.dropzone.files;
    },
    pdfTextChanged() {
      [this.entity.pdf_text] = this.$refs.dropzonePdfText.dropzone.files;
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body);
      if (this.entity.date) postFormData.append('date', this.entity.date);
      if (this.entity.pdf || this.entity.pdf_text) postFormData.append('chunkedFile', true);
      if (this.entity.featured) postFormData.append('featured', _.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}letterbooks`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const { acceptedFiles } = this.dropzoneOptions;
      const dispatchStartUpload = (contentType, entityId, file, type) => {
        this.$store.dispatch('uploadManager/startUpload', {
          apiHost: host,
          apiPrefix: prefix,
          entityId,
          files: [file],
          token,
          contentType,
          acceptedFiles,
          file_type: type,
        });
      };
      this.saveRequest().then((response) => {
        this.$_successSave();
        const { content_type: contentType, id: entityId } = response.data;
        if (this.entity.pdf) {
          dispatchStartUpload(contentType, entityId, this.entity.pdf, 'pdf');
        }
        if (this.entity.pdf_text) {
          dispatchStartUpload(contentType, entityId, this.entity.pdf_text, 'pdf_text');
        }
        this.$parent.getSource();
        window.location.hash = `#/admin/content/book/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create Letterbook query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?2f5142f4